import { render, staticRenderFns } from "./verify-email.vue?vue&type=template&id=738ff33d&scoped=true&"
import script from "./verify-email.vue?vue&type=script&lang=js&"
export * from "./verify-email.vue?vue&type=script&lang=js&"
import style0 from "./verify-email.vue?vue&type=style&index=0&id=738ff33d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ff33d",
  null
  
)

export default component.exports